import Scroll from './Scroll'

const scroll = new Scroll()


export default
{
    created()
    {
        this.scroll = scroll
    },

    mounted()
    {
        if (this.onScroll)
        {
            this.scroll.addOnScroll(this.onScroll)
        }
        else
        {
            console.warn(`Use the method onScroll(y) if you use the mixin-scroll in your component`, this.$el)
        }
    },

    destroyed()
    {
        if (this.onScroll)
        {
            this.scroll.removeOnScroll(this.onScroll)
        }
    }
}
